module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-container-columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_c('entity-text', {
    attrs: {
      "text": "welcomeTextTitle"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-partial"
  }, [_c('div', {
    staticClass: "card-partial-content"
  }, [_c('p', [_c('entity-text', {
    attrs: {
      "text": "welcomeText"
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n                Aankomende\r\n                "), _c('entity-text', {
    attrs: {
      "text": "voyage"
    }
  }), _vm._v(" "), (_vm.entity.name == 'friendshipcruises') ? _c('i', {
    staticClass: "fa fa-ship  pull-right"
  }) : _vm._e()], 1)]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoadingReservation
    }
  }), _vm._v(" "), (!_vm.isLoadingReservation) ? _c('div', {
    staticClass: "card-content"
  }, [(_vm.upcomingRes) ? _c('div', [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_c('entity-text', {
    attrs: {
      "text": "destination"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.travel_package_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.start_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.end_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.days) + " dagen")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.reservation_number))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('router-link', {
    staticClass: "md-btn pull-right",
    attrs: {
      "tag": "button",
      "to": {
        name: 'reservation',
        params: {
          reservationId: _vm.upcomingRes.id
        }
      }
    }
  }, [_vm._v("\r\n                      Meer info\r\n                    ")])], 1)])]) : _c('div', [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v("Geen aankomende "), _c('entity-text', {
    attrs: {
      "text": "voyage"
    }
  })], 1)])])])]) : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Vertrekdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Terugkomstdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Aantal dagen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Reserveringsnummer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e7b5186"}!./src/templates/portal/dashboard.html
// module id = 536
// module chunks = 1